import { PayablePoolToken, Token } from '@ui/types/token';
import { Nullable } from '@ui/types/utility';
import { useAccount } from 'wagmi';

import { useErc20Balance } from './useErc20Read';
import { useNativeTokenBalance } from './useNativeToken';

export const usePayTokenBalance = (
  token: Nullable<Token>,
  refetchInterval?: number,
) => {
  const { address } = useAccount();
  const { data: nativeTokenBalance } = useNativeTokenBalance({
    refetchInterval,
  });

  const { data: erc20TokenBalance } = useErc20Balance({
    account: address,
    decimals: token?.isNative ? null : token?.decimals,
    tokenAddress: token?.isNative ? null : token?.address,
    refetchInterval,
  });

  if (token?.isNative) {
    return nativeTokenBalance;
  } else {
    return erc20TokenBalance;
  }
};
